export default __webpack_public_path__ + "static/media/screenshot_org_dashboard_purple.21329115.png";